<template lang="pug">
  VContainer.paused__container
    h1.paused__title(
      tabindex="0"
    )
      span.t--yellow.inline Mint&nbsp;
      span.inline Paused

    VBtn.v-btn--home(
      x-large
      rounded
      dark
      :elevation="0"
      :href="homeUrl"
    ) Back to Home
</template>

<script>
export default {
  name: 'MintPaused',
  computed: {
    homeUrl() {
      return process.env.VUE_APP_LANDING_URL;
    },
  },
};
</script>

<style lang="scss">
.paused__title {
  font-family: $font-primary;
  color: $white;
  font-size: 3rem;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;

  @include small-mobile {
    font-size: 2.125rem;
  }

  @include tablet {
    font-size: 4rem;
  }

  @include desktop {
    font-size: 4.5rem;
  }

  @include wide-desktop {
    font-size: 7rem;
  }

  @include big {
    font-size: 9.5rem;
  }

  span {
    display: block;
    position: relative;

    &.inline {
      display: inline-block;
    }
  }
}
</style>
